
import apiClient from './ApiInterceptor';

export const fetchTamagotchi= async (user_id) => {
    const response = await apiClient.get(`/tamagotchi/${user_id}`);
    return response;
};

export const patchTamagotchi= async (user_id, params ) => {
    try {
        const response = await apiClient.patch(`/tamagotchi/${user_id}`, params);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('TamagotchiApi - nameTamagotchi, Error naming tamagotchi:', error);
        return { success: false, error };
    }
}

export const fetchTamagotchiLevel = async (level) => {
    const response = await apiClient.get(`/tamagotchi/level/${level}`);
    return response;
};

export const fetchTamagotchiStatus = async (tamagotchi) => {
    const params = {
        score: calculateStatus(tamagotchi),
    }
    const response = await apiClient.get('/tamagotchi/status', { params });
    return response;
};

const calculateStatus = (tamagotchi) => {
    const stats = ["strength", "endurance", "power", "fun", "flexibility", "coordination", "balance"];
    const total = stats.reduce((acc, stat) => acc + tamagotchi[stat], 0);
    const average = total / stats.length;
    return average;
};